import React from 'react'
import BluetoothInterduction from './BluetoothInterduction'
import BluetoothUser from './BluetoothUser'
import BluetoothAdmin from './BluetoothAdmin'

const BluetoothMainContent = () => {
  return (
    <>
        <BluetoothInterduction/>
        <BluetoothUser/>
        <BluetoothAdmin/>
    </>
  )
}

export default BluetoothMainContent